
import './App.css';
import Initative from './component/initative';
import Content from './component/content';
import Mid from './component/mid';
import Navbar from './component/navbar';
import Upcoming from './component/upcoming';
import Form from './component/form';
import Footer from './component/footer';


function App() {
  return (
    <div>
      <Navbar/>
      <Mid/>
      <Content/>
      < Initative/>
      <Upcoming/>
      <Form/>
      <Footer/>
    </div>
    
  );
}

export default App;
